export const GuaranteeAgreementRouting = [
  {
    path: "/maintenance/guarantee-agreement",
    name: "maintenance-guarantee-agreement-list",
    meta: { title: "保修协议" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-guarantee-agreement" */ "@/views/maintenance/guarantee-agreement/list/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/guarantee-agreement/create",
    name: "maintenance-guarantee-agreement-create",
    meta: { title: "新建保修协议", comName: "MaintenanceGuaranteeAgreementFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-guarantee-agreement" */ "@/views/maintenance/guarantee-agreement/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/guarantee-agreement/edit/:id",
    name: "maintenance-guarantee-agreement-edit",
    meta: { title: "编辑保修协议", comName: "MaintenanceGuaranteeAgreementFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-guarantee-agreement" */ "@/views/maintenance/guarantee-agreement/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/guarantee-agreement/detail/:id",
    name: "maintenance-guarantee-agreement-detail",
    meta: { title: "保修协议详情" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-guarantee-agreement" */ "@/views/maintenance/guarantee-agreement/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/guarantee-agreement/flowPrint/:id",
    name: "maintenance-guarantee-agreement-flow-print",
    meta: { title: "保修协议打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-guarantee-agreement" */ "@/views/maintenance/guarantee-agreement/flow-print/index.vue"
      ),
  },
];
